module.exports = __webpack_public_path__ + "static/media/Concept_CapitalCity.62d46f06.jpg";